export default "__VITE_ASSET__Dgavlq0e__"